import { useState } from 'react';
import { Link } from 'react-router';
import { api } from '../lib/api';
import { AuthScene } from './AuthScene';

/**
 * Восстановление пароля через бота.
 *
 * Ответ одинаков всегда, нашёлся аккаунт или нет: иначе форма превращается
 * в способ выяснять, кто зарегистрирован в системе.
 */
export function RecoverPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setBusy(true);
    try {
      await api.recoverPassword(email);
    } catch {
      // Молча: показывать разницу между «не нашли» и «не смогли» здесь нельзя,
      // а человеку в обоих случаях делать одно и то же.
    }
    setBusy(false);
    setSent(true);
  };

  if (sent) {
    return (
      <AuthScene>
        <div className="auth__state">
          <div className="auth__stateIcon">📨</div>
          <h1 className="auth__stateTitle">Проверьте Telegram</h1>
          <p className="auth__stateText">
            Если этот адрес есть в системе и к нему привязан Telegram, новый пароль уже пришёл в чат
            с ботом.
          </p>
          <p className="auth__stateText" style={{ marginTop: 16 }}>
            <Link to="/login" className="auth__back">
              Вернуться ко входу
            </Link>
          </p>
        </div>
      </AuthScene>
    );
  }

  return (
    <AuthScene>
      <h1 className="auth__title">Восстановление пароля</h1>

      <form onSubmit={onSubmit} noValidate>
        <label className="auth__field">
          <span className="auth__label">Почта</span>
          <input
            className="auth__input"
            type="email"
            autoComplete="username"
            placeholder="you@example.com"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
        </label>

        <p className="auth__hint">
          Новый пароль придёт в Telegram — в чат с ботом. Он работает, если мессенджер привязан в
          настройках кабинета.
        </p>

        <button className="auth__submit" type="submit" disabled={busy || !email}>
          {busy ? 'Отправляем…' : 'Прислать новый пароль'}
        </button>
      </form>

      <p className="auth__footer">
        <Link to="/login" className="auth__back">
          Вернуться ко входу
        </Link>
      </p>
    </AuthScene>
  );
}
